import { Component, computed, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { Tooltip } from 'primeng/tooltip';
import { LaunchApplicationService } from '../../../services/launch-application/launch-application.service';
import { IconPipe } from '../../../pipes/icon/icon.pipe';

@Component({
  selector: 'fw-pages-nav-bar',
  imports: [
    ButtonModule,
    FontAwesomeModule,
    RouterModule,
    MenuModule,
    Tooltip,
    IconPipe,
  ],
  templateUrl: './pages-nav-bar.component.html',
  styleUrl: './pages-nav-bar.component.scss',
})
export class PagesNavBarComponent {
  private readonly launchApplicationService = inject(LaunchApplicationService);
  protected readonly pagesTabs = this.launchApplicationService.pagesTabs;

  protected readonly topTabs = computed(() =>
    this.pagesTabs().filter((tab) => tab.top)
  );
  protected readonly bottomTabs = computed(() =>
    this.pagesTabs().filter((tab) => !tab.top)
  );
  isActive = signal<boolean>(false);
}
